import Vue from 'vue'
import Vuex from 'vuex'
import JwtService from "@/common/jwt.service";
import router from '@/router'
import axios from 'axios'
import * as d3 from 'd3';
import * as d3Array from 'd3-array';

import createPersistedState from 'vuex-persistedstate'
import {
  HomeService,
  DashboardService,
  LoginService,
} from '@/common/api.service';

Vue.use(Vuex)

const media = process.env.NODE_ENV == 'development'
  ? 'https://onigies.unam.mx/media/'
  : ''

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {

    /********************     HOME    ****************************/

    init_ready: false,
    view_ready: false,
    axis_ready: true,
    //show_charts: false,
    ises: undefined,
    indicadores: undefined,
    last_values: undefined,
    ejes: undefined,
    current_axis: undefined,
    axes_means: undefined,
    current_ies: undefined,
    segmentos: undefined,
    gpos_segmento: undefined,
    valid_periods: undefined,
    loading_update: false,
    current_period: undefined,
    current_ises: undefined,
    indicators_means: undefined,
    page_setup: undefined,
    current_period_axis: undefined,
    current_period_ies: undefined,

    /********************    LOGIN   ****************************/
    is_logging_in: true,
    in_loading: false,
    tipos_pob: undefined,
    snackbar_obj: {enabled: false, text:""},

    /********************  DASHBOARD  ****************************/
    is_dashboard: false,
    user_onigies_details : {},
    all_status: [],
    periods: undefined,
    status_ies: [],
    last_period: undefined,
    current_period_detail: undefined,
    is_authenticated: !!JwtService.getToken(),
    ies_data: undefined,
    ies_year_data:{},
  },
  getters: {
    show_charts: state => state.view_ready && state.init_ready 
                          && state.axis_ready
  },
  mutations: {
    SET_AUTH(state, user) {
      state.is_authenticated = true;
      state.is_logging_in = false;
      state.user_onigies_details = user;
      state.is_ies = !!user.ies_id;
      JwtService.saveToken(user.token);
    },
    PURGE_AUTH(state) {
      state.is_authenticated = false;
      state.is_logging_in = false;
      state.user_onigies_details = {};
      JwtService.destroyToken();
    },
    SET_IS_LOGGING_IN(state, is_logging_in) {
      state.is_logging_in = is_logging_in;
    },
    SET_IS_DASHBOARD(state, is_dashboard) {
      state.is_dashboard = is_dashboard;
    },
    SET_IN_LOADING(state, in_loading) {
      state.in_loading = in_loading;
    },

    /********************    HOME    ****************************/

    RESTORE_VUEX(state) {
      state.init_ready = false;
      state.view_ready = false;
      //state.show_charts = false;
      state.ises = undefined
      state.indicadores = undefined
      state.last_values = undefined
      state.current_axis = undefined
      state.axes_means = undefined
      state.current_ies = undefined
      state.valid_periods = undefined
      state.current_period = undefined
      state.indicators_means = undefined
    },
    SET_INIT_READY(state, val) {
      state.init_ready = val;
    },
    SET_VIEW_READY(state, val) {
      state.view_ready = val;
    },
    SET_AXIS_READY(state, val) {
      state.axis_ready = val;
    },
    /*SET_SHOW_CHARTS(state, show) {
      state.show_charts = show;
    },*/
    SET_LOADING_UPDATE(state, loading) {
      state.loading_update = loading;
    },
    SET_ISES(state, data_ises) {
      state.ises = data_ises.map(ies=>{
        if (media && ies.logo){
          const idx_pos = ies.logo.lastIndexOf('/ies')
          ies.logo = `${media}${ies.logo.substr(idx_pos+1)}`
        }
        return ies
      });
    },
    SET_LAST_VALUES(state, [data, year]) {
      /*if (!year)
        state.current_period = state.valid_periods[state.valid_periods.length-1]
      else
        state.current_period = state.valid_periods.find(vp=> vp.year == year);
      */
      state.last_values = data;
      if (year || !state.current_period)
        state.current_period = state.valid_periods.find(x=> x.id == data.id);
    },
    SET_VALID_PERIODS(state, periods) {
      state.valid_periods = periods;
      state.current_period = periods[d3Array.maxIndex(periods, d => d.year)]
    },
    SET_CAT_INDICADORES(state, data_cat) {
      state.indicadores = data_cat.indicadores
      state.ejes = data_cat.ejes.map(eje=>(
        {...eje, ...{logo: `${media}${eje.logo}`}}))
      state.page_setup = data_cat.page_setup
    },
    SET_CAT_TIPOS_POB(state, data_cat) {
      state.tipos_pob = data_cat
    },
    SET_POB_CATS(state, data_cat) {
      state.segmentos = data_cat.segmentos
      state.gpos_segmento = data_cat.grupos_segmento
      state.tipos_pob = data_cat.tipos_grupo_segmento
    },
    SET_AXIS(state, axis){
      axis.mean_value = state.axes_means 
        ? state.axes_means[`${axis.id}`] : axis.mean_value
      state.current_axis = axis
    },
    SET_AXIS_PERIODS(state, periods){
      state.current_period_axis = periods
    },
    SET_AXES(state, means){
      state.axes_means = means
    },
    SET_AXIS_MEAN(state, all_ies){
      state.current_axis.mean_value = all_ies.index
      state.indicators_means = all_ies
    },
    SET_POBLATIONS(state, data){
      state.poblations = data
    },
    SET_CURRENT_ISES(state, ises){
      state.current_ises = ises
    },

    
    /********************  DASHBOARD  ****************************/

    CLEAN_STATES(state){
      state.valid_periods = undefined
      state.current_period_detail = undefined
      state.last_period = undefined
    },
    SET_PERIODS(state, data_periods) {
      state.periods = data_periods;
      state.last_period= data_periods[d3Array.maxIndex(data_periods, 
        d => d.actions_available)]
    },
    SET_STATUS_RESPUESTA(state, data_status) {
      state.all_status = data_status;
    },
    SET_STATUS_IES(state, data_status) {
      state.status_ies = data_status;
    },
    SET_CURRENT_PERIOD(state, data_period){
      state.current_period_detail = data_period;
    },
    SET_IES(state, data) {
      state.ies_data = data;
    },    
    SET_IES_HOME(state, [data, year]) {
      if (media && data.logo){
        const idx_pos = data.logo.lastIndexOf('/ies')
        data.logo = `${media}${data.logo.substr(idx_pos+1)}`
      }
      state.current_ies = data;
      var curr_period = data.period_ies.find(x=>
        x.id == data.current_period)
      state.current_period_ies = curr_period
      var curr_year = state.valid_periods.find(x=> 
        x.id == curr_period.year);
      if (year || !state.current_period)
        state.current_period = curr_year

    },
    SET_YEAR_IES(state, data) {
      state.ies_year_data = data;
    },
    CHANGE_PERIOD_IES_BASE(state, data){
      state.ies_year_data.register_referance = data.register_referance
    },
    CHANGE_ANSWER(state, data){
      var res_idx = state.ies_year_data.data.ejes.respuestas.findIndex(x=>x.id==data.id) 
      state.ies_year_data.data.ejes.respuestas.splice(res_idx, 1, data)
    },
    CHANGE_POBLATION(state, data){
      var pob_idx = state.ies_year_data.data.grupo_poblacion.findIndex(x=>
        x.grupo_segmento.id==data.grupo_segmento.id)
      state.ies_year_data.data.grupo_poblacion[pob_idx].status = data.status
    },
    UPDATE_FILE_NAMES(state, data){
      state.ies_year_data.data.ejes.respuestas.find(x=>x.id==data.id).files = data.files
      state.ies_year_data.data.ejes.respuestas.find(x=>x.id==data.id).status = data.status
    },
    SET_SNACKBAR(state, text){
      state.snackbar_obj = {enabled:true, text:text};
    },

  },
  actions: {


    //************************** HOME       **************************

    SHOW_CHARTS({commit}, show) {
      commit("SET_SHOW_CHARTS", show)
    },
    CLEAN_VUEX({commit}) {
      commit("RESTORE_VUEX")
      commit("SET_IS_DASHBOARD", false)
    },
    FETCH_ISES({state, commit}) {
      return new Promise (resolve => {
        HomeService.fetchIses()
          .then(({data}) => {
            commit('SET_ISES', data)
            return resolve(data)
          })
      })
    },
    FETCH_INDICADOR_VALUES({state, commit}, year=null) {
      commit("SET_LOADING_UPDATE", true)
      return new Promise (resolve => {
        if (state.current_period && !year)
          year = state.current_period.year
        HomeService.fetchIndicadorValues(year)
          .then(({data}) => {
            commit('SET_LAST_VALUES', [data, year])
            commit("SET_LOADING_UPDATE", false)
            return resolve(data)
          })
      })
    },
    FETCH_POBLATIONS({state, commit}, year) {
      return new Promise (resolve => {
        HomeService.fetchPoblations(year)
          .then(({data}) => {
            commit('SET_POBLATIONS', data)
            return resolve(data)
          })
      })
    },    
    FETCH_CAT_INDICADORES({state, commit}) {
      return new Promise (resolve => {
        HomeService.fetchCatIndicadores().then(({data}) => {
          commit('SET_CAT_INDICADORES', data)
          return resolve(data)
        })
      })
    },
    FETCH_CAT_TIPOS_POB({state, commit}) {
      return new Promise (resolve => {
        HomeService.fetchCatTiposPob().then(({data}) => {
          commit('SET_CAT_TIPOS_POB', data)
          return resolve(data)
        })
      })
    },
    FETCH_CAT_POBS({state, commit}) {
      return new Promise (resolve => {
        HomeService.fetchCatPobs()
          .then(({data}) => {
            commit('SET_POB_CATS', data)
            return resolve(data)
          })
      })
    },    
    GET_AXIS({state, commit, dispatch}, slug) {
      var curr_slug = slug || router.currentRoute.params.slug
      //var curr_axis = slug ? slug : router.currentRoute.params.slug
      var axis = state.ejes.find(x=>x.slug==curr_slug)
      commit('SET_AXIS', axis)
      dispatch("GET_AXIS_PERIODS", axis.id)
      return true
    },
    GET_AXIS_PERIODS({state, commit}, axis_id){
      commit("SET_IN_LOADING", true)
      return new Promise (resolve => {
        HomeService.getAxis(axis_id).then(({data}) => {
          commit('SET_AXIS_PERIODS', data.periods)
          commit("SET_IN_LOADING", false)
          //return resolve(data)
        })
      })
    },
    FETCH_VALID_PERIODS({state, commit}) {
      return new Promise (resolve => {
        HomeService.fetchValidPeriods().then(({data}) => {
          commit('SET_VALID_PERIODS', data)
          return resolve(data)
        })
      })
    },
    GET_IES({state, commit}, params={}) {
      const curr_ies = params.ies_id || router.currentRoute.params.ies_id
      // console.log(params.year)
      /*if (state.ises){
        let new_ies = state.ises.find(ies=>ies.id == curr_ies)
        console.log(new_ies)
      }*/
      const query_params = params.year ? `?year=${params.year}` : ''
      commit("SET_IN_LOADING", true)
      return new Promise (resolve => {
        HomeService.getIes(curr_ies, query_params).then(({data}) => {
          //commit('SET_CURRENT_PERIOD_H', data)
          commit("SET_IN_LOADING", false)
          commit('SET_IES_HOME', [data, params.year])
          return resolve(data)
        })
      })
    },
    GENERATE_EXCEL({state, commit}, year) {
      return new Promise (resolve => {
        HomeService.generateExcel(year).then(({data}) => {
          return resolve(data)
        })
      })
    },
    AXES_MEANS({state, commit}, means) {
      commit('SET_AXES', means)
    },
    CURRENT_ISES({state, commit}, values) {
      commit('SET_CURRENT_ISES', values)
    },
    AXIS_MEAN({state, commit}, all_ies) {
      commit('SET_AXIS_MEAN', all_ies)
    },

    //**************************LOGIN**************************

    CHECK_AUTH({state, commit, dispatch}){
      commit("SET_IS_LOGGING_IN", true)
      commit("SET_IS_DASHBOARD", true)
      return new Promise (resolve => {
        //primero comprobamos que exista token de usuario
        if (!!JwtService.getToken()) {
          console.log("hay token")
          dispatch("REDIRECT_LOGIN")
          dispatch("GET_LOGIN")
        } else
          //Si no hay token, directamente intenta generar un login con Facebook
          return resolve(dispatch("HAS_NOT_LOGGED", 'No estaba logueado'))
      })
    },
    LOGIN({commit, dispatch}, credentials){
      commit("SET_IN_LOADING", true)
      return LoginService.login(credentials)
        .then(({data}) => {
          commit('SET_AUTH', data)
          dispatch("REDIRECT_LOGIN")
          return data
        })
    },
    GET_LOGIN({dispatch, commit}){
      commit("SET_IS_DASHBOARD", true)
      commit("SET_IN_LOADING", true)
      return LoginService.getLogin()
        .then(({data}) => {
          commit('SET_AUTH', data)
          dispatch("REDIRECT_LOGIN")
          return data
        })
        .catch(err=>{
          console.log(err)
          dispatch("HAS_NOT_LOGGED", 'No estaba logueado')
        })
    },
    REDIRECT_LOGIN({state, commit, dispatch}, intern=false){
      let route_name = router.currentRoute.name
      commit("SET_IS_LOGGING_IN", false)
      if (route_name === 'Login' || route_name === 'Dashboard' || intern)
        if (!!state.user_onigies_details.ies_id)
          router.push({ path: `/dashboard/ies/${state.user_onigies_details.ies_id}`})
        else{
          router.push({ path: `/dashboard/ies_list/`})
        }
    },
    HAS_LOGGED(context, userData) {
      context.commit("PURGE_AUTH");
      context.commit("SET_AUTH", userData)
      context.dispatch("REDIRECT_LOGIN");
    },
    HAS_NOT_LOGGED(context, error_message) {
      context.commit("PURGE_AUTH");
      if (router.currentRoute.name != 'Login')
        router.replace({ name: 'Login' });
      context.commit("SET_IS_LOGGING_IN", false);
      console.log({error:error_message})
    },
     LOGOUT(context) {
      context.commit("PURGE_AUTH")
      router.push({ name: 'Login' })
    },

    //**************************DASHBOARD-PERIOD-IES**************************

    CLEAN_STATE({state, commit}){
      commit('CLEAN_STATES')
    },
    FETCH_STATUS_RESPUESTAS({state, commit}) {
      return new Promise (resolve => {
        DashboardService.fetchStatusRespuesta()
          .then(({data}) => {
            commit('SET_STATUS_RESPUESTA', data)
            return resolve(data)
          })
      })
    },
    FETCH_STATUS_IES({state, commit}) {
      return new Promise (resolve => {
        DashboardService.fetchStatusIes()
          .then(({data}) => {
            commit('SET_STATUS_IES', data)
            return resolve(data)
          })
      })
    },
    UPDATE_PERIOD_IES_BASE({state, commit}, new_data){
      return new Promise (resolve => {
        DashboardService.updatePeriodIesData(new_data).then(({data})=>{
          commit("CHANGE_PERIOD_IES_BASE", data)
          commit("SET_SNACKBAR", new_data.snack_text)
          return resolve(data)
        })
      })
    },
    UPDATE_ANSWER({state, commit}, new_data){
      if (new_data.error){
        commit("SET_SNACKBAR", "Hubo un error al guardar el status")
        return
      }
      return new Promise (resolve => {
        DashboardService.updateAnswer(new_data).then(({data})=>{
          commit("CHANGE_ANSWER", data)
          commit("SET_SNACKBAR", new_data.snack_text)
          return resolve(data)
        })
      })
    },
    UPDATE_NOTE({state, commit}, new_data){
      return new Promise (resolve => {
        DashboardService.updateNote(new_data).then(({data})=>{
          commit("CHANGE_ANSWER", data)
          commit("SET_SNACKBAR", new_data.snack_text)
          return resolve(data)
        })
      })
    },
    UPDATE_ANSWER_WITH_PREVIOUS({state, commit}, new_data){
      DashboardService.usePreviousResponse(new_data).then(({data})=>{
        commit("CHANGE_ANSWER", data)
        commit("SET_SNACKBAR", new_data.snack_text)
        return data
      })
    },
    POST_FILE({state, commit}, new_data){
      return new Promise (resolve => {
        DashboardService.postNewFile(new_data).then(({data})=>{
          commit("UPDATE_FILE_NAMES", data)
          commit("SET_SNACKBAR", new_data.snack_text)
          return resolve(data)
        })
      })
    },
    DELETE_FILE({state, commit}, new_data){
      return new Promise (resolve => {
        DashboardService.deleteFile(new_data).then(({data})=>{
          commit("UPDATE_FILE_NAMES", data)
          commit("SET_SNACKBAR", new_data.snack_text)
          return resolve(data)
        })
      })
    },
    //*********************DASHBOARD-PERIOD-IES Poblaciones *********************

    
    UPDATE_GRUPO_SEGMENTO({state, commit}, new_data){
      return new Promise (resolve => {
        DashboardService.updateGrupoSegmento(new_data).then(({data})=>{
          commit("CHANGE_POBLATION", data)
          commit("SET_SNACKBAR", new_data.snack_text)
          return resolve(data)
        })
      })
    },

    //**************************DASHBOARD-IES_LIST**************************

    FETCH_PERIODS({state, commit}) {
      return new Promise (resolve => {
        DashboardService.fetchPeriods()
          .then(({data}) => {
            commit('SET_PERIODS', data)
            return resolve(data)
          })
      })
    },
    GET_PERIOD({state, commit}, last_period){
      last_period = last_period || state.last_period
      //console.log(last_period)
      return new Promise (resolve => {
        DashboardService.getPeriod(last_period.id, last_period.stage)
          .then(({data}) => {
            commit('SET_CURRENT_PERIOD', data)
            return resolve(data)
          })
      })
    },
    GET_IES_DATA({state, commit}, ies_id){
      commit("SET_IN_LOADING", true)
      return new Promise (resolve => {
        DashboardService.getIesData(ies_id).then(({data})=>{
          commit("SET_IN_LOADING", false)
          return resolve(commit('SET_IES', data))
        })
      })
    },
    UPDATE_LOGO({state, commit}, new_data){
      commit("SET_IN_LOADING", true)
      return new Promise (resolve => {
        DashboardService.updateLogo(new_data).then(({data})=>{
          commit("SET_IN_LOADING", false)
          //console.log(data)
          return resolve(commit('SET_IES', data))
        })
      })
    },
    GET_YEAR_IES_DATA({state, commit}, period_ies_id){
      commit("SET_IN_LOADING", true)
      return new Promise (resolve => {
        DashboardService.fetchPeriodIesData(period_ies_id).then(({data})=>{
          commit("SET_IN_LOADING", false)
          return resolve(commit('SET_YEAR_IES', data))
        })
      })
    },
  }
})
